import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledDeleteReservationContent } from './styles/StyledDeleteReservationContent';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import TitleTop from '../../common/TitleTop/TitleTop';

class DeleteReservationContent extends Component {
  render() {
    const {
      deleteReservation,
      deleteReservationData,
    } = this.props;

    let title;
    let message;
    let icon;
    let style;

    if (deleteReservationData.isLoading) {
      return (
        <StyledDeleteReservationContent>
          <TitleTop
            title="Probíhá mazání"
          />
          <div className="delete-reservation-laoder">
            <LoadingSpinner />
          </div>
        </StyledDeleteReservationContent>
      );
    }

    if (deleteReservationData.status) {
      style = "success";
      title = "Rezervace byla smazána";
      message = "Vaše rezervace byla úspěšně smazána.";
      icon = 'fa-check';

    } else if (!deleteReservationData.errorType.time) {
      style = "error";
      title = "Rezervaci nelze smazat";
      message = "Rezervace neexistuje.";
      icon = 'fa-exclamation-triangle';

    } else if (!deleteReservationData.errorType.completed) {
      style = "error";
      title = "Rezervaci nelze smazat";
      message = "Rezervace neexistuje.";
      icon = 'fa-exclamation-triangle';

    } else if (!deleteReservationData.errorType.deleted) {
      style = "error";
      title = "Rezervaci nelze smazat";
      message = "Tato rezervace byla již smazána.";
      icon = 'fa-exclamation-triangle';

    } else if (!deleteReservationData.errorType.emailConfirmed) {
      style = "error";
      title = "Rezervaci nelze smazat";
      message = "Rezervaci nelze smazat.";
      icon = 'fa-exclamation-triangle';

    } else {
      style = "warning";
      title = "Něco se nepovedlo";
      message = "Nepodařilo se navázat spojení. Zkuste prosím stránku načíst znovu, nebo opakujte akci později.";
      icon = 'fa-exclamation-triangle';
    }


    return (
      <StyledDeleteReservationContent>
        <div>
          <TitleTop
            title={title}
          />

          <table className={'delete-reservation-table-' + style}>
            <tbody>
              <tr>
                <td className={'delete-reservation-icon-' + style}>
                  <i className={'fa ' + icon} aria-hidden="true"></i>
                </td>
                <td className="delete-reservation-text">
                  {message}
                </td>
              </tr>
            </tbody>
          </table>

          {style === "warning" && (
            <button
              className="delete-reservation-btn"
              onClick={deleteReservation}
            >
              Zkusit znovu
            </button>
          )}

        </div>
      </StyledDeleteReservationContent>
    );
  }
}


DeleteReservationContent.propTypes = {
  deleteReservation: PropTypes.func.isRequired,
  deleteReservationData: PropTypes.shape({
    isLoading: PropTypes.bool.isRequired,
    status: PropTypes.bool.isRequired,
    errorType: PropTypes.shape({
      time: PropTypes.bool.isRequired,
      completed: PropTypes.bool.isRequired,
      deleted: PropTypes.bool.isRequired,
      emailConfirmed: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};


export default DeleteReservationContent;


// WEBPACK FOOTER //
// ./src/components/DeleteReservationContent/DeleteReservationContent.js